module.exports = "https://cdn.dove.it/_next/static/public/assets/agent-showing-house-2.5286b6c87b458c6aa53dd3787574b5d0.jpg";